import { RiskLevel } from "../scoring/rules";

interface Props {
  level: RiskLevel;
  score: number;
}

const labelMap: Record<RiskLevel, string> = {
  low: "Low",
  medium: "Medium",
  high: "High"
};

export default function RiskBadge({ level, score }: Props) {
  return (
    <span className={`badge ${level}`} aria-label={`Risk level ${labelMap[level]}`}>
      {labelMap[level]} ({score})
    </span>
  );
}
